import React from 'react';
import { Outlet } from 'react-router-dom';

function FeatureBasePage() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default FeatureBasePage;
